import { render, staticRenderFns } from "./delete-audience-warning.vue?vue&type=template&id=c3b93d04&scoped=true"
import script from "./delete-audience-warning.vue?vue&type=script&lang=js"
export * from "./delete-audience-warning.vue?vue&type=script&lang=js"
import style0 from "./delete-audience-warning.vue?vue&type=style&index=0&id=c3b93d04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b93d04",
  null
  
)

export default component.exports